import * as React from 'react'
import { DVString } from 'DVWebNodeUtils'
import { Text as DVStringProcessor } from '@amzn/dvui/dist/Text';
import { Icon, IconType } from '@amzn/dvui/dist/Icon';
import { WarningAlert } from '@amzn/dvui/dist/Alert';
import * as styles from './Infobox.module.scss';
import * as cn from 'classnames'

export interface InfoboxProps {
    message: DVString
    type?: string
    className?: string
}

export const Infobox = (props: InfoboxProps) => {
    const preIcon = !Boolean(props.type) ? <Icon use={IconType.ENTITLED_TICK} className={styles.customIcon} /> : <></>
    const processedString = <DVStringProcessor string={props.message} className={styles.text} />
    const wrappedIfWarning = props.type == "warn" ? <WarningAlert>{processedString}</WarningAlert> : processedString
    return (<div className={cn(styles.Infobox, props.className)} >
        {preIcon}
        {wrappedIfWarning}
    </div>)
}